import { PlayersFrom } from "@/redux/players/playersSlice";

import {
  both as bothIcon,
  club as clubIcon,
  market as marketIcon,
} from "../../../icons";
import SegmentedControls from "../SegmentedControls/SegmentedControls";

type Props = {
  disabled?: boolean;
  playersFrom: PlayersFrom;
  onClick: (playersFrom: PlayersFrom) => void;
};

export const FiltersPlayersFrom = ({
  playersFrom,
  onClick,
  disabled,
}: Props) => {
  return (
    <SegmentedControls
      activeValue={playersFrom}
      grayScale={true}
      expandedVersion={true}
      disabled={disabled}
      options={[
        {
          onClick: () => onClick("market"),
          icon: marketIcon,
          value: "market",
          label: (
            <div className="flex flex-col items-end">
              <div>Transfer</div>
              <div>Market</div>
            </div>
          ),
        },
        {
          onClick: () => onClick("both"),
          icon: bothIcon,
          value: "both",
          label: "Both",
        },
        {
          onClick: () => onClick("club"),
          icon: clubIcon,
          value: "club",
          label: "Club",
        },
      ]}
    />
  );
};
